(function($){
  $(function(){

    // Setting Up Global Variables to be used in JS - Denotes which template is which so JavaScript is used only on proper templates
    var BODY      	      	  = $('body'),
        IS_INDEX              = (BODY.hasClass('index-template')) ? true : false,
        IS_COLLECTION         = (BODY.hasClass('collection-template')) ? true : false,
        IS_COLLECTION_LISTING = (BODY.hasClass('list-collections-template')) ? true : false,
        IS_PRODUCT            = (BODY.hasClass('product-template')) ? true : false,
        IS_PRODUCT            = (BODY.hasClass('product-template')) ? true : false,
        IS_BLOG               = (BODY.hasClass('blog-template')) ? true : false,
        IS_ARTICLE            = (BODY.hasClass('article-template')) ? true : false,
        IS_SEARCH             = (BODY.hasClass('search-template')) ? true : false,
        IS_PAGE	              = (BODY.hasClass('page-template')) ? true : false,
        IS_CART               = (BODY.hasClass('cart-template')) ? true : false,
        HAS_PRODUCTS          = ($('.product').length > 0) ? true : false;
    
    var isMobileMenuOpen = false;
    function closeMobileMenu(){
      $('body').removeClass('mobile-nav-opened');
      $('#mobile-nav-toggle').removeClass('opened');
      $('#mobile-nav-wrapper').removeClass('fadeIn');
      isMobileMenuOpen = false;
    }
    function openMobileMenu(){
      $('html, body').stop().animate({scrollTop: 0}, 0);
      $('body').addClass('mobile-nav-opened');
      $('#mobile-nav-toggle').addClass('opened');
      $('#mobile-nav-wrapper').addClass('fadeIn');
      isMobileMenuOpen = true;
    }
    $('#mobile-nav-toggle').click(function() {
      if (isMobileMenuOpen){
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
      return false;
    });
  }); 
})(jQuery)

// Modal Popup


$(window).load(function(){
  // Test browser support for cookies and only run if we can
  var cookies = navigator.cookieEnabled || ("cookie" in document && (document.cookie.length > 0 || (document.cookie = "test").indexOf.call(document.cookie, "test") > -1));
  if (cookies == true){
    function loadModal(){
      $.fancybox({
        type: 'inline',
        href: '#modal',
        maxWidth: 600,
        height: 'auto',
        padding: 0,
        afterClose: function (){
          $.cookie('tmg_newsletter_signup', 'false', {expires:60, path:'/', domain:'tmgguitarco.com'});
        }
      });
    }
    if ($.cookie('tmg_newsletter_signup') != 'false') {
      setTimeout(function(){
        loadModal();
      }, 3000);
    }
    function successCallback(resp){
      if (resp.result === 'success') {
        $.cookie('tmg_newsletter_signup', 'false', {expires:365, path:'/', domain:'tmgguitarco.com'});
        $('#mc-modal-email').hide();
        $('#mc-modal-subscribe').hide();
        $('#mce-message').html('<p class="success">Awesome, check your email.</p>').fadeIn();
                               setTimeout(function(){
          $.fancybox.close();
        }, 2500);
      }
      else {
        $('#mce-message').html('<p class="error">Sorry, something went wrong. Please try again.</p>').fadeIn().delay(3500).fadeOut();
      }
    }
    $('#mc-subscribe-modal-form').ajaxChimp({
      callback: successCallback
    });
  };
});

